export default __webpack_public_path__ + "static/media/129.83d3b5ea.png";